export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export const CATEGORIES = [
  "Energy", "Technology", "Health", "Education", "Agriculture", "Finance",
  "Environment", "Infrastructure", "Real Estate", "Transport", "Entertainment",
  "Sports", "Science", "Arts", "Government", "Water", "Housing", "Security",
  "Tourism", "Media", "Social Impact", "Fashion", "Food", "Religion", "Charity", "Legal"
];

export const CURRENCIES = [
  {code: "NGN", symbol: "₦", name: "Nigerian Naira"},
  {code: "USD", symbol: "$", name: "US Dollar"}
];

export const LOCATIONS = {
  "Africa": ["Nigeria", "South Africa", "Kenya", "Egypt", "Ghana", "Ethiopia", "Tanzania", "Morocco", "Algeria", "Uganda"],
  "Asia": ["India", "China", "Japan", "Indonesia", "Vietnam", "Thailand", "Malaysia", "Philippines", "South Korea", "Singapore"],
  "Europe": ["United Kingdom", "Germany", "France", "Italy", "Spain", "Netherlands", "Sweden", "Switzerland", "Poland", "Belgium"],
  "North America": ["United States", "Canada", "Mexico"],
  "South America": ["Brazil", "Argentina", "Chile", "Colombia", "Peru", "Venezuela", "Ecuador", "Bolivia"],
  "Oceania": ["Australia", "New Zealand", "Fiji", "Papua New Guinea"]
};

export const SOCIAL_PLATFORMS = [
  { key: "Instagram", placeholder: "https://instagram.com/yourpage" },
  { key: "Facebook", placeholder: "https://facebook.com/yourpage" },
  { key: "X", placeholder: "https://x.com/yourhandle" },
  { key: "LinkedIn", placeholder: "https://linkedin.com/company/yourcompany" },
  { key: "TikTok", placeholder: "https://tiktok.com/@yourhandle" },
  { key: "YouTube", placeholder: "https://youtube.com/@yourchannel" },
  { key: "Telegram", placeholder: "https://t.me/yourchannel" },
  { key: "WhatsApp", placeholder: "https://wa.me/yournumber" },
  { key: "Threads", placeholder: "https://threads.net/@yourhandle" },
  { key: "Snapchat", placeholder: "https://snapchat.com/add/yourhandle" },
];
